import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import DoctorCard from '@components/DoctorCard/DoctorCard';
import FooterButtons from '@components/Button/FooterButtons';
import * as actions from '../../actions';
import * as Constants from '../../constants';

require('./DoctorSelectionPage.scss');

const staticText = {
  loading: 'Loading doctors...',
  empty: 'No doctors available. Please try again.',
  backBtn: 'Back to Speciality',
  proceedBtn: 'Proceed to Slot Selection',
  cancelBtn: 'Cancel Order',
};

class DoctorSelectionPage extends Component {
  componentDidMount() {
    const { selectedSpeciality } = this.props.docConsult;
    if (selectedSpeciality) {
      this.props.actions.fetchDoctors(selectedSpeciality);
    }
    this.props.actions.changeHeaderState(Constants.DOC_CONSULT_SELECT_DOCTOR);
  }

  handleSelect = (doctor) => {
    this.props.actions.setSelectedDoctor(doctor);
  }

  handleProceed = () => {
    browserHistory.push('/doc-consult/slot-patient');
  }

  render() {
    const { doctorsData, doctorsTitle, doctorLoading, selectedDoctor } = this.props.docConsult;

    return (
      <div className="doctorSelectionWrapper">
        <div className="doctorSelectionContainer">
          {doctorsTitle && <p className="doctorSelectionTitle">{doctorsTitle}</p>}

          {doctorLoading && (
            <p className="doctorSelectionLoading">{staticText.loading}</p>
          )}

          {!doctorLoading && doctorsData.length === 0 && (
            <p className="doctorSelectionError">{staticText.empty}</p>
          )}

          {!doctorLoading && doctorsData.length > 0 && (
            <div className="doctorList">
              {doctorsData.map(doctor => (
                <DoctorCard
                  key={doctor.id}
                  doctor={doctor}
                  selectedDoctorId={selectedDoctor && selectedDoctor.id}
                  onSelect={this.handleSelect}
                />
              ))}
            </div>
          )}
        </div>

        <FooterButtons
          backBtnText={staticText.backBtn}
          backBtnClick={() => browserHistory.push('/doc-consult/select-speciality')}
          proceedBtnText={staticText.proceedBtn}
          proceedBtnClick={this.handleProceed}
          nextStateAllowed={!!selectedDoctor}
          cancelBtnText={staticText.cancelBtn}
          cancelBtnClick={() => browserHistory.push({ pathname: '/customer-info', state: { alreadyVisitedCustomerInfoPage: true } })}
        />
      </div>
    );
  }
}

DoctorSelectionPage.propTypes = {
  docConsult: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default connect(
  state => ({ docConsult: state.docConsult }),
  dispatch => ({ actions: bindActionCreators(actions, dispatch) })
)(DoctorSelectionPage);
